import dayjs        from 'dayjs';
import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class DemandLogisticModel extends ApiModel {
  static get path() {
    return '/backend/demand_logistics/{?id}';
  }

  @computed
  get height() {
    return this.get('height');
  }

  @computed
  get width() {
    return this.get('width');
  }

  @computed
  get means() {
    return this.get('means');
  }

  @computed
  get weight() {
    return this.get('weight');
  }

  @computed
  get length() {
    return this.get('length');
  }

  @computed
  get pickupDatetime() {
    return this.get('pickupDatetime');
  }

  @computed
  get pickupDatetimeDate() {
    return this.pickupDatetime ? dayjs(this.pickupDatetime) : null;
  }
}
